module.exports = __webpack_public_path__ + "img/clopotel-notificari.d98a5dda.svg";